<template>
  <no-ssr>
  <label class="file-select">
    <div class="select-button">
      <span v-if="value" :title="value.name">{{titleSelected}}{{cutDocName(value.name, 16)}}</span>
      <span class="title-select" v-else>{{title}}</span>
    </div>
    <input type="file" @change="handleFileChange"/>
  </label>
    </no-ssr>
</template>

<script>
  import StringMixin from '../mixins/StringMixin.js'

  export default {
    props: {
      value: File,
      title: { type: String, default: 'Прикрепить файл' },
      titleSelected: { type: String, default: 'Выбранный файл: ' },
    },
    mixins: [StringMixin],
    methods: {
      handleFileChange(e) {
        this.$emit('input', e.target.files[0])
      }
    }
  }
</script>

<style lang="scss" scoped>

  .file-select {

    & > .select-button {
      display: flex;display: -ms-flexbox;
      flex-flow: row nowrap;
      align-items: center;

      height: 65px;
      padding: 5px 15px 25px 70px;
      position: relative;
      @include font-size(18px, 22px);
      @include ease(all, 0s);
      text-transform: uppercase;
      text-decoration: none;
      white-space: nowrap;
      cursor: pointer;
      color: $color-text;
      &:before {
        @include pseudo;
        @include size(60px);
        left: 0;
        top: 0;
        background: url('/images/ui/attach-file.png') top left no-repeat;
        background-size: auto 100%;
      }
      .title-select {
        text-decoration: underline;
      }
    }

    & > input[type="file"] {
      display: none;
    }

  }
</style>



// WEBPACK FOOTER //
// components/shared/_any/InputFile.vue